<template>
    <div class="controls">
        <!-- 播放/暂停 -->
        <a href="javascript:;" :class="[ isplay?'switch fa fa-pause':'switch fa fa-play' ]" @click="pasuePlay"></a>
        <!-- 全屏 -->
        <a href="javascript:;"  :class="[ isfull?'expand fa fa-arrows':'expand fa fa-expand' ]" @click="fullscreen"></a>
        <!-- 声音 -->
<!--        <a href="javascript:;"  :class="[ isvolume?'volume fa fa-volume-up':'volume fa fa-volume-off' ]" @click="muted"></a>-->
        <!-- 进度条 -->
        <div class="progress">
            <div class="loaded"></div>
            <div class="line"></div>
            <div class="bar"></div>
        </div>
        <!-- 时间 -->
        <div class="timer">
            <span class="current">00:00</span> /
            <span class="total">00:00</span>
        </div>
        <!-- 声音 -->
    </div>
</template>

<script>
    export default {
        name: "index",
        props:["index"],
        data(){
          return {
              isplay:true,
              isfull:false,
              isvolume:false
          }
        },
        mounted() {
            var progress = document.querySelector(".progress");
            var loaded = document.querySelector(".progress > .loaded");
            var currPlayTime = document.querySelector(".timer > .current");
            var totalTime = document.querySelector(".timer > .total");
            var isPlayd = document.querySelector(".switch");
            console.log("#video"+this.index);
            var that = this;
            document.querySelector("#video"+this.index).onmouseover = function(){
                document.querySelector(".controls").style.opcity = 1;
            },
            document.querySelector("#video"+this.index).oncanplay = function(){
                //显示视频
                this.style.display = "block";
                //显示视频总时长
                totalTime.innerHTML = that.getFormatTime(this.duration);
            };
            document.querySelector("#video"+this.index).ontimeupdate = function(){
                var currTime = this.currentTime,    //当前播放时间
                    duration = this.duration;       // 视频总时长
                //百分比
                var pre = currTime / duration * 100 + "%";
                //显示进度条
                loaded.style.width = pre;

                //显示当前播放进度时间
                currPlayTime.innerHTML = that.getFormatTime(currTime);
            };
            document.querySelector("#video"+this.index).onended = function(){
               // var that = this;
                //切换播放按钮状态
                // isPlayd.classList.remove("fa-pause");
                // isPlayd.classList.add("fa-play");
                //进度条为0
                loaded.style.width = 0;
                //还原当前播放时间
                currPlayTime.innerHTML = that.getFormatTime();
                //视频恢复到播放开始状态
                this.currentTime = 0;
                that.reend();
            };
            progress.onclick = function(e){
                var event = e || window.event;
                let video = document.querySelector("#video"+that.index);

                video.currentTime = (event.offsetX / this.offsetWidth) * video.duration;
            };

        },
        methods: {
             getFormatTime(time) {
                var time = time || 0;
                var h = parseInt(time/3600),
                m = parseInt(time%3600/60),
                s = parseInt(time%60);
                h = h < 10 ? "0"+h : h;
                m = m < 10 ? "0"+m : m;
                s = s < 10 ? "0"+s : s;
                return m+":"+s;
             },
            reend(){
                 this.isplay = false;
                 document.querySelector("#video"+this.index).pause()
                 let that = this;
                 setTimeout(function () {
                     that.isplay = true;
                     document.querySelector("#video"+that.index).play();
                 })

            },
            pasuePlay(){
                if(this.isplay){
                    this.isplay = false;
                    document.querySelector("#video"+this.index).pause()
                }else{
                    this.isplay = true;
                    document.querySelector("#video"+this.index).play()
                }
            },
            fullscreen(){
                if(this.isfull){
                   // this.isfull = false;
                    document.querySelector("#video"+this.index).exitFullscreen()
                }else{
                    this.isfull = true;
                    document.querySelector("#video"+this.index).requestFullscreen()
                }
            },
            muted(){
                if(this.isvolume){
                     this.isvolume = false;
                    document.querySelector("#video"+this.index).volume = 0;
                }else{
                    this.isvolume = true;
                    document.querySelector("#video"+this.index).volume = 0.5;
                }
            }
        }
    }
</script>

<style scoped>
    @import "/player/css/font-awesome.css";
    @import "/player/css/player.css";
</style>